import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormArray, Validators, FormBuilder } from '@angular/forms';
import { Params, Router } from '@angular/router';
import { createPopper } from '@popperjs/core';
import { LoginService } from '../../services/login.service';
import swal from 'sweetalert2';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent extends FeaturesBaseComponent implements OnInit {
  forgotForm: FormGroup;
  notification = new FormControl('sms');

  constructor(
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.forgotForm = this.formBuilder.group({
      userName: [null, Validators.required],
      notification: this.notification
    });
  }

  submit() {
    if (!this.forgotForm.valid) {
      return;
    }

    //
    let httpParams = new HttpParams()
      .set('userName', this.forgotForm.get('userName').value)
      .set('notification', this.forgotForm.get('notification').value)


    //

    this.loginService.forgotPassword(httpParams).subscribe(
      e => {

        if (e && e.httpcode == 200) {
          let _userName = e.data.userName;
          swal.fire(
            {
              position: 'top-end',
              icon: 'success',
              title: 'Verify to proceed',
              showConfirmButton: false,
              timer: 1500
            }
          )
          let _userMethod: any = {
            username: _userName,
            notification: this.forgotForm.value.notification,
            notifyBy : e.data.notificationDetails
          }

          localStorage.setItem('userVerify', JSON.stringify(_userMethod))

          localStorage.setItem('isFrom', 'forgot');
          this.router.navigate(['/verify'])
          return;
        }
       
        return;
      }
    );
  }
}
